import React from 'react';
import {useTranslation} from 'react-i18next';

/**
 * LO SCHELETRO DEL CASINO': la lobby disegnata a vuoto.
 *
 * Compare quando il fornitore non da' giochi (non e' configurato, non
 * risponde, o l'elenco e' vuoto) e sta SOTTO la nota che dice perche': la
 * nota e' la verita', lo scheletro e' la forma. Segue le scelte del
 * backoffice -- griglia o righe, misura delle copertine (le classi
 * `cas-piccole|medie|grandi` sulla lobby), cuore dei preferiti, «Prova»,
 * fornitori -- cosi' chi sta scegliendo il modulo vede com'e' fatto anche
 * prima di avere un fornitore.
 *
 * Non inventa niente: nessun nome di gioco, nessun fornitore, nessuna
 * immagine. Sono riquadri tratteggiati con barre al posto dei testi, fermi
 * (non e' un caricamento: non c'e' niente in arrivo) e nascosti ai lettori
 * di schermo; la nota resta l'unico testo da leggere.
 */

const TRE = [0, 1, 2];

/** Un riquadro: la copertina vuota, le due barre del nome, cuore e «Prova» se il modulo li tiene accesi.
 *  `inArrivo`: i giochi stanno arrivando, e il riquadro luccica come una copertina che carica
 *  (non tratteggiato: quello dice «qui non c'e' niente»). */
export function Segnaposto({conCuore, conProva, inArrivo}) {
  return (
    <div className={'cas-gioco cas-segnaposto' + (inArrivo ? ' cas-in-arrivo' : '')}>
      <div className={'cas-quadro'}><span>▶</span></div>
      {conCuore && <span className={'cas-cuore-vuoto'}>♥</span>}
      <div className={'cas-didascalia'}>
        <span className={'cas-barra corta'}/>
        <span className={'cas-barra media'}/>
      </div>
      {conProva && <span className={'cas-prova-vuota'}/>}
    </div>
  );
}

/** Una riga che scorre di riquadri vuoti (come quella dei giochi nella Home). */
export function RigaSegnaposto({quanti = 6, className = '', conCuore, conProva, inArrivo}) {
  return (
    <div className={'cas-scorre ' + className} aria-hidden={'true'}>
      {Array.from({length: quanti}, (_, i) => <Segnaposto key={i} conCuore={conCuore} conProva={conProva} inArrivo={inArrivo}/>)}
    </div>
  );
}

/** La lobby intera a vuoto: categorie, poi righe per categoria o griglia, secondo il modulo. */
export default function ScheletroLobby({modulo}) {
  const {t} = useTranslation();
  const aRighe = modulo.disposizione === 'righe';
  return (
    <div className={'cas-scheletro'}>
      <p className={'cas-scheletro-nota'}>
        {t('Anteprima della lobby: i riquadri si riempiono con i giochi del fornitore appena ci sono.')}
      </p>
      <div aria-hidden={'true'}>
        <div className={'cas-categorie lvc-strip'}>
          <span className={'cas-categoria scelta'}>{t('Tutti')}</span>
          {TRE.map((i) => <span key={i} className={'cas-categoria vuota'}/>)}
          {modulo.preferiti && <span className={'cas-categoria'}>♥ {t('Preferiti')}</span>}
        </div>
        {aRighe
          ? [0, 1].map((i) => (
            <section className={'cas-riga'} key={i}>
              <div className={'cas-riga-testa'}><span className={'cas-barra titolo'}/></div>
              <RigaSegnaposto quanti={6} conCuore={modulo.preferiti} conProva={modulo.prova}/>
            </section>
          ))
          : (
            <div className={'cas-griglia'}>
              {Array.from({length: 12}, (_, i) => <Segnaposto key={i} conCuore={modulo.preferiti} conProva={modulo.prova}/>)}
            </div>
          )}
      </div>
    </div>
  );
}
